import { INTERNAL_USER_AGENTS, vars } from '@repo/config';
import { buildMediaVaultUnreachableDetail } from '@repo/config/errors';
import { CloudflareError, initializeClient } from '@repo/sdk';
import { showGlobalError } from './global-error-dialog';

const CLOUDFLARE_OVERLOADED_MESSAGE = 'Server is overloaded, please retry in a moment.';

async function getServerCookieHeaders(): Promise<Record<string, string>> {
  if (typeof window !== 'undefined') {
    return {};
  }
  try {
    const { headers } = await import('next/headers');
    const headersList = await headers();
    const cookie = headersList.get('cookie');
    if (cookie) {
      return { cookie };
    }
  } catch {}
  return {};
}

const isBrowser = typeof window !== 'undefined';
const baseUrl = isBrowser ? '/api/gw' : vars.url.apiUrl;
const defaultHeaders: Record<string, string> = isBrowser
  ? { 'x-client-info': JSON.stringify({ platform: 'web' }) }
  : { 'user-agent': INTERNAL_USER_AGENTS.webSsr };

initializeClient({
  baseUrl,
  defaultHeaders,
  headerProvider: getServerCookieHeaders,
  onError: (error) => {
    if (typeof window === 'undefined') {
      return;
    }
    if (error instanceof CloudflareError) {
      showGlobalError(
        error.reason === 'tunnel'
          ? buildMediaVaultUnreachableDetail(error.code)
          : CLOUDFLARE_OVERLOADED_MESSAGE,
      );
    }
  },
  onUnauthorized: async (): Promise<Record<string, string> | null> => {
    if (typeof window !== 'undefined') {
      const { refreshSession } = await import('./refresh-session');
      const refreshed = await refreshSession();
      return refreshed ? {} : null;
    }
    const freshHeaders = await getServerCookieHeaders();
    return freshHeaders.cookie ? freshHeaders : null;
  },
});
